import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Styles from "./Footer.module.scss";
import { TrustPilotWidget } from "@/shared/components/TrustPilot/TrustPilotComponents";
import {
  becomePartnerLink,
  companyLink,
  contactLink,
  dataprivacyLink,
  faqLink,
  imprintLink,
  jobsLink,
  mediaLink,
  offerElectricityLink,
  offerGasLink,
} from "../Header/Navigation/Links";
import classNames from "classnames";
import { useFlavour } from "@/shared/flavours/useFlavour";
import Icon from "@/shared/components/Icon/Icon";
const SocialLinks = {
  Instagram: "https://www.instagram.com/remindme_official",
  TikTok: "https://www.tiktok.com/@remind.me_de?_t=8msyapa9hSK&_r=1",
  Facebook: "https://www.facebook.com/profile.php?id=61560404879009",
  Youtube: "https://www.youtube.com/@remindme_de",
};
const Footer = () => {
  const { FooterLogo } = useFlavour();
  const { t } = useTranslation();

  return (
    <div className={Styles.footer} id="footerNavigation">
      <div className={Styles.topSection}>
        <div className={Styles.logoPlaceholder}>
          <img src={FooterLogo} className={Styles.logo} height={"30px"} width={"92px"} alt="remind.me" />
        </div>
        <div className={Styles.lists}>
          <div className={Styles.listGroup}>
            <ul>
              <li>
                <Link to={companyLink} data-cy="footer-unternehmen-link">
                  {t("footer.aboutUs")}
                </Link>
              </li>
              <li>
                <Link to={faqLink} data-cy="footer-faq-link">
                  {t("footer.faq")}
                </Link>
              </li>
              <li>
                <Link to={contactLink} data-cy="footer-kontakt-link">
                  {t("footer.contact")}
                </Link>
              </li>
            </ul>
          </div>
          <div className={Styles.listGroup}>
            <ul>
              <li>
                <Link to={imprintLink} data-cy="footer-impressum-link">
                  {t("footer.imprint")}
                </Link>
              </li>
              <li>
                <Link to={dataprivacyLink} data-cy="footer-data-link">
                  {t("footer.dataPrivacy")}
                </Link>
              </li>
              <li>
                <Link to={mediaLink} data-cy="footer-presse-link">
                  {t("footer.media")}
                </Link>
              </li>
            </ul>
          </div>
          <div className={Styles.listGroup}>
            <ul>
              <li>
                <Link to={jobsLink} data-cy="footer-jobs-link">
                  {t("footer.jobs")}
                </Link>
              </li>
              <li>
                <div
                  style={{ cursor: "pointer" }}
                  data-cy="footer-cookie-settings-link"
                  //@ts-expect-error UC_UI is not typed yet
                  onClick={() => window.UC_UI && window.UC_UI.showSecondLayer()}
                >
                  {t("footer.cookieSettings")}
                </div>
              </li>
              <li>
                <Link to={becomePartnerLink} data-cy="footer-become-partner-link">
                  {t("footer.becomePartner")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={classNames(Styles.logoTrustPilot, Styles.placeholder)}>
          <TrustPilotWidget templateId={"trustpilotDefault"} />
        </div>
      </div>
      <div className={Styles.bottomSection}>
        <div className={Styles.placeholder} />
        <div className={Styles.lists}>
          <div className={Styles.listGroup}>
            <ul>
              <li className={Styles.groupName}>{t("footer.electricity")}</li>
              <li>
                <Link to={offerElectricityLink} data-cy="footer-cheap-electricity-link">
                  {t("footer.cheapElectricity")}
                </Link>
              </li>
            </ul>
          </div>
          <div className={Styles.listGroup}>
            <ul>
              <li className={Styles.groupName}>{t("footer.gas")}</li>
              <li>
                <Link to={offerGasLink} data-cy="footer-cheap-gas-link">
                  {t("footer.cheapGas")}
                </Link>
              </li>
            </ul>
          </div>
          <div className={Styles.listGroup}>
            <ul>
              <li className={Styles.groupName}>{t("footer.findUsHere")}</li>
              <li>
                <div className={Styles.socialIconsContainer}>
                  <Link target="_blank" to={SocialLinks.Instagram}>
                    <Icon name="instagram"></Icon>
                  </Link>
                  <Link target="_blank" to={SocialLinks.TikTok}>
                    <Icon name="tiktok"></Icon>
                  </Link>
                  <Link target="_blank" to={SocialLinks.Facebook}>
                    <Icon name="facebook"></Icon>
                  </Link>
                  <Link target="_blank" to={SocialLinks.Youtube}>
                    <Icon name="youtube"></Icon>
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className={Styles.placeholder}></div>
      </div>
      <div className={Styles.signature}>
        <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
      </div>
    </div>
  );
};

export default Footer;
